import type { Template } from "@/types";

export const PO_05_H4_V1: Template[] = [
    {
        id: "po-05-h4v1-01",
        name: "PO 01 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 59, y: 258, width: 477, height: 335, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 657, y: 212, width: 195, height: 137, rotation: 0, imageRotation: 0 },
            { id: "3", x: 657, y: 357, width: 195, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 657, y: 502, width: 195, height: 137, rotation: 0, imageRotation: 0 },
            { id: "5", x: 859, y: 212, width: 273, height: 427, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-02",
        name: "PO 02 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_02.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 181, y: 87, width: 235, height: 163, rotation: 0, imageRotation: 0 },
            { id: "2", x: 181, y: 258, width: 235, height: 163, rotation: 0, imageRotation: 0 },
            { id: "3", x: 181, y: 429, width: 235, height: 163, rotation: 0, imageRotation: 0 },
            { id: "4", x: 181, y: 600, width: 235, height: 162, rotation: 0, imageRotation: 0 },
            { id: "5", x: 686, y: 87, width: 413, height: 676, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-03",
        name: "PO 03 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 32, y: 215, width: 292, height: 207, rotation: 0, imageRotation: 0 },
            { id: "2", x: 32, y: 430, width: 292, height: 207, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 0, width: 526, height: 850, rotation: 0, imageRotation: 0 },
            { id: "4", x: 866, y: 215, width: 292, height: 207, rotation: 0, imageRotation: 0 },
            { id: "5", x: 866, y: 430, width: 292, height: 207, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-04",
        name: "PO 04 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 26, y: 163, width: 547, height: 390, rotation: 0, imageRotation: 0 },
            { id: "2", x: 726, y: 163, width: 335, height: 526, rotation: 0, imageRotation: 0 },
            { id: "3", x: 26, y: 560, width: 178, height: 128, rotation: 0, imageRotation: 0 },
            { id: "4", x: 212, y: 560, width: 177, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 397, y: 560, width: 177, height: 128, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-05",
        name: "PO 05 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_05.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 30, y: 331, width: 267, height: 188, rotation: 0, imageRotation: 0 },
            { id: "2", x: 305, y: 331, width: 267, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 171, y: 135, width: 268, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 171, y: 527, width: 268, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 711, y: 135, width: 363, height: 580, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-06",
        name: "PO 06 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_06.png",
        size: [1190, 850],
        style: {},
        slots: [          
            { id: "1", x: 0, y: 353, width: 200, height: 144, rotation: 0, imageRotation: 0 },
            { id: "2", x: 208, y: 353, width: 199, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 415, y: 135, width: 360, height: 580, rotation: 0, imageRotation: 0 },
            { id: "4", x: 783, y: 353, width: 200, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 991, y: 353, width: 199, height: 144, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-07",
        name: "PO 07 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 530, height: 850, rotation: 0, imageRotation: 0 },
            { id: "2", x: 655, y: 193, width: 474, height: 336, rotation: 0, imageRotation: 0 },
            { id: "3", x: 655, y: 537, width: 153, height: 120, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 537, width: 153, height: 120, rotation: 0, imageRotation: 0 },
            { id: "5", x: 977, y: 537, width: 153, height: 120, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-08",
        name: "PO 08 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 73, y: 66, width: 450, height: 718, rotation: 0, imageRotation: 0 },
            { id: "2", x: 643, y: 248, width: 246, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 643, y: 430, width: 246, height: 173, rotation: 0, imageRotation: 0 },
            { id: "4", x: 897, y: 248, width: 246, height: 174, rotation: 0, imageRotation: 0 },
            { id: "5", x: 897, y: 430, width: 246, height: 173, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-09",
        name: "PO 09 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 221, width: 555, height: 407, rotation: 0, imageRotation: 0 },
            { id: "2", x: 563, y: 221, width: 366, height: 272, rotation: 0, imageRotation: 0 },
            { id: "3", x: 937, y: 221, width: 252, height: 407, rotation: 0, imageRotation: 0 },
            { id: "4", x: 563, y: 501, width: 179, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 750, y: 501, width: 179, height: 127, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-10",
        name: "PO 10 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_10.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 222, width: 171, height: 127, rotation: 0, imageRotation: 0 },
            { id: "2", x: 179, y: 222, width: 170, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 357, width: 349, height: 271, rotation: 0, imageRotation: 0 },
            { id: "4", x: 357, y: 222, width: 551, height: 406, rotation: 0, imageRotation: 0 },
            { id: "5", x: 916, y: 222, width: 273, height: 406, rotation: 0, imageRotation: 0 }
        ],
    }
];